import React from "react";
import { ListGroup, ListGroupItem } from 'reactstrap'
import { ManageGroup } from "./actionButtons/ManageGroup";
import { FormattedMessage } from 'react-intl';
import {
  DEFAULT_ADMIN_USER_GROUP_NAME
} from '../../../../../../config/constants';

function ListGroupsForUsers(props) {
  const {
    groups,
    addUserInGroup,
    removeUserFromGroup,
    displayUsersGroup,
  } = props;

  if (! Array.isArray( groups ) || groups.length === 0) {
    return (
      <ListGroup className="users-list">
        <ListGroupItem className="user-item">
          <FormattedMessage id="messages.no_data"/>
        </ListGroupItem>
      </ListGroup>
    );
  }

  const renderItem = (group, index) => {
    if (group.name === DEFAULT_ADMIN_USER_GROUP_NAME) {
      return;
    }
    return (
      <ListGroupItem key={index} className="user-item">
        <span className="user-name">{`${group.name}`}</span>
        <ManageGroup
          addUserInGroup={addUserInGroup}
          removeUserFromGroup={removeUserFromGroup}
          group={group}
          displayUsersGroup={displayUsersGroup}
          showIcon={true}
          index={index}
        />
      </ListGroupItem>
    );
  }

  return (
    <ListGroup className="users-list">
      {groups.map( renderItem )}
    </ListGroup>
  );
}

export { ListGroupsForUsers }
